var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-truncate"},[_c('link-cell',{attrs:{"href":_vm.projectUrl,"data-testid":"job-project-link"}},[_vm._v(_vm._s(_vm.projectName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }